import { isNonEmptyString } from './isNonEmptyString';

/**
 * Reduces a value to the characters a number can be built from - digits and a
 * decimal point - as a string.
 *
 * This is the inverse of `toCurrencyString` / `toNumberString`: it takes what a
 * user sees (`$1,234.56`) and returns what gets stored (`1234.56`). Use
 * `toDigits` instead when a decimal point would be meaningless, as it is for
 * the positional masks.
 */
export const toNumericString = (value?: string | number | null): string => {
  if (isNonEmptyString(value)) {
    return value.replace(/[^.\d]/g, '');
  }

  return typeof value === 'number' ? Math.abs(value).toString() : '';
};
